export const CODE_LENGTH = 4;
